var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNordicUploadDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 53.6 62.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1{stroke-linecap:round;}\r\n      .cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}\r\n      .cls-1,.cls-3{fill:none;stroke:#7D6630;stroke-width:2px;}\r\n      .cls-2{fill:#585857;stroke:#585857;}\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    className: "cls-2",
    d: "M27.92,12.52H7.42c-.39,0-.7-.31-.7-.7,0-.39,.31-.7,.7-.7H27.92c.39,0,.7,.31,.7,.7s-.31,.7-.7,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    className: "cls-2",
    d: "M24.09,48.52H7.25c-.32,0-.58-.31-.58-.7s.26-.7,.58-.7H24.09c.32,0,.58,.31,.58,.7s-.26,.7-.58,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    className: "cls-2",
    d: "M39.37,21.52H7.41c-.39,0-.7-.31-.7-.7,0-.39,.31-.7,.7-.7h31.96c.39,0,.7,.31,.7,.7,0,.39-.31,.7-.7,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    className: "cls-2",
    d: "M39.37,30.52H7.41c-.39,0-.7-.31-.7-.7s.31-.7,.7-.7h31.96c.39,0,.7,.31,.7,.7s-.31,.7-.7,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    className: "cls-2",
    d: "M28.09,60.74H2.96c-.59,0-1.07-.48-1.07-1.07V2.96c0-.59,.48-1.07,1.07-1.07h29.92c.6,0,1.09,.48,1.1,1.08l.15,8.56c.03,1.36,1.13,2.44,2.49,2.45h8.63c.26,0,.51,.1,.7,.28l.09,.09c.18,.19,.28,.44,.28,.7v20.9c0,.38,.3,.69,.68,.69h.01c.39,0,.7-.31,.7-.7V15.04c0-.44-.12-.87-.35-1.24-.03-.11-.08-.2-.16-.28l-.14-.14c-.05-.06-.1-.11-.16-.16L34.6,1.17c-.07-.07-.14-.12-.23-.15-.43-.33-.95-.52-1.49-.52H2.96c-1.36,0-2.46,1.1-2.46,2.46H.5V59.67c0,1.36,1.1,2.46,2.46,2.46H28.09c.36-.01,.5-.3,.5-.7,0-.62-.27-.69-.5-.69ZM36.6,12.57c-.6,0-1.08-.48-1.1-1.08l-.13-7.62,8.86,8.7h-7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    className: "cls-2",
    d: "M25.98,39.52H7.26c-.35,0-.64-.31-.64-.7,0-.39,.29-.7,.64-.7H25.98c.35,0,.64,.31,.64,.7s-.29,.7-.64,.7h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 40.6,
    cy: 49.82,
    r: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.6,
    y1: 58.16,
    x2: 40.6,
    y2: 42.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.82,48.25l6.71-5.68s.1-.03,.14,0l6.71,5.68"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordicUploadDocument);
export default __webpack_public_path__ + "static/media/nordic_upload_document.55f43b7c8d6bdea12862326554aa5d51.svg";
export { ForwardRef as ReactComponent };